import React, { useEffect, useState } from "react";
import "./login.css";
import { Link, useNavigate } from "react-router-dom";
import { New_ScrollX2025, SliderArrowIcon, Scrollx_animate } from "../../../assets/icons";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { login } from "../../../Redux/actions/authActions";
import {
  getUserAllInformation,
  hasUserFilledSurvey,
} from "../../../Redux/actions/commonActtion";
import SuccessModal from "../../Dashboard/SuccessModal";
import { ToastContainer } from "react-toastify";
import SignUpWithGoogle from "../../GoogleSignUp/SignUpWithGoogle";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMesg, setErrorMesg] = useState("");

  const [path, setPath] = useState("");
  const [successModal, setSuccessModal] = useState(false);

  const [signInLoading, setSignInLoading] = useState(false);
  const [move, setMove] = useState(false);

  const [form, setForm] = useState({
    data: { email: "", password: "" },
    errorMessage: { email: "", password: "" },
  });

  const submitHandler = async (e) => {
    e.preventDefault();
    setSignInLoading(true);
    setErrorMesg("");

    try {
      const res = await dispatch(login(email, password));

      if (res?.status === 200) {
        // ✅ Wait for user information to be fetched before showing success
        await dispatch(getUserAllInformation());

        const userFilledSurvey = await hasUserFilledSurvey();
        localStorage.setItem(
          "userFilledSurvey",
          JSON.stringify(userFilledSurvey),
        );

        setSuccessModal(true);
        setPath("/register");
        setErrorMesg("");
      } else if (
        res?.response?.status === 400 &&
        res?.response?.data?.error &&
        !res?.response?.data?.success
      ) {
        setErrorMesg("Incorrect username or password.");
        setSuccessModal(false);
      } else {
        // ✅ Ensure data is loaded before navigation
        await dispatch(getUserAllInformation());
        navigate("/dashboard");
      }
    } catch (error) {
      console.log("error", error);
      setErrorMesg("An unexpected error occurred. Please try again.");
    }

    setSignInLoading(false);
  };

  

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClick = () => {
    setMove(true); // Move to 0px

    setTimeout(() => {
      setMove(false); // Return to 100px after a short delay
    }, 3000); // Adjust the delay as needed (1000ms = 1 second)
  };

useEffect(() => {
  document.body.style.backgroundColor = "#0d0d1a"; // match your dark bg
  document.body.style.margin = "0";
  return () => {
    document.body.style.backgroundColor = "";
  };
}, []);

  const CloseButton = ({ closeToast }) => (
    <i
      className="material-icons w-7 flex justify-center cursor-pointer not-italic"
      onClick={closeToast}
    >
      ✖
    </i>
  );

  return (
    <>
      <ToastContainer closeButton={CloseButton} />

      {successModal && (
        <SuccessModal
          successModal={successModal}
          setSuccessModal={setSuccessModal}
          errorMesg={errorMesg}
          path={path}
        />
      )}

      {signInLoading && (
        <div className="modal-overlayLoader">
          <img
            className="absolute opacity-80"
            src={Scrollx_animate}
            width="120px"
            height="120px"
            alt=""
          />
          <p className="mt-[8rem] text-[0.9rem] text-white">Signing in...</p>
        </div>
      )}

      <div className="login-container" style={{ minHeight: "100vh", minHeight: "-webkit-fill-available" }}>
        <div className="particles"></div>
        <div className="shell">
          <header class="topbar">
            <nav className="w-full flex justify-between">
              <a href="https://scrollx.io/" className="nav-logo">
                <span className="nav-logo-icon">
                  <img className="logo-img999 " src={New_ScrollX2025} alt="icon" />
                </span>              
                <span>ScrollX</span>
              </a>            

            <div className="top-actionslogin">
              <span className=" hidden sm:block">New to ScrollX?</span>
              <Link to="/register">
                <span className="text-white  sm:block xl:text-[15px] manrope-300 ">Create Account</span>
              </Link>
            </div>
            </nav>
          </header>

          <main className="login-page">
            <section className="left">
              <div className="form-wrap">
                <p className="eyebrow">Welcome Back</p>
                <h1 className="login-heading">
                  Continue your
                  <br />
                  <em>end credits.</em>
                </h1>
                <p className="sub">
                  Access saved projects, make revisions, and render fresh
                  exports anytime.
                </p>

                <form
                  className="form-cardlogin"
                  onSubmit={submitHandler}
                  method="post"
                >
                  <div className="google-btn-wrapper">
                    <div className="google-custom-overlay">
                      <span className="google-icon">G</span>
                      <span>Continue with Google</span>
                    </div>
                    <div className="google-actual-button">
                      <SignUpWithGoogle />
                    </div>
                  </div>

                  <div className="divider">or log in with email</div>
                  {/* Email */}
                  <div className="field">
                    <label htmlFor="email" className="login-field-label">Work email</label>
                    <input
                      id="email"
                      type="email"
                      className="login-field-input"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="ava@studio.com"
                      required
                    />
                  </div>
                  {/* Password */}
                  <div className="field">
                    <label htmlFor="password" className="login-field-label">Password</label>
                    <div className="password-field-wrap">
                      <input
                        id="password"
                        type={showPassword ? "text" : "password"}
                        className="login-field-input"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Enter your password"
                        required
                      />
                      <button
                        type="button"
                        className="eye-toggle"
                        onClick={handleShowPassword}
                      >
                        {showPassword ? <FaEye /> : <FaEyeSlash />}
                      </button>
                    </div>
                  </div>

                  {/* Error Message */}
                  <div className="">
                    {errorMesg && (
                      <p className="text-white manrope-400 text-sm ">
                        {errorMesg}
                      </p>
                    )}
                  </div>

                  <div className="form-row forgot-only">
                    <Link className="text-sm" to="/forgotpassword">
                      Forgot your Password?
                    </Link>
                  </div>

                  {/* Login Button */}
                  <button
                    className="submit"
                    type="submit"
                    onClick={handleClick}
                  >
                    Log In <span>→</span>
                  </button>

                  <p className="termsLogin">
                    Trouble logging in?
                    <a href="https://scrollx.io/contact/" className="ml-1">
                      Contact support
                    </a>
                  </p>
                </form>
              </div>
            </section>

            <section className="rightlogin">
              <div className="right-inner">
                <div className="value-card">
                  <h2>
                    Your saved settings,
                    <br />
                    <em>ready to render.</em>
                  </h2>

                  <div className="feature-list">
                    <div className="feature">
                      <span className="check">
                        <svg viewBox="0 0 16 16" fill="none" stroke-width="2">
                          <path
                            d="M4 8l3 3 5-5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      Saved credit projects
                    </div>
                    <div className="feature">
                      <span className="check">
                        <svg viewBox="0 0 16 16" fill="none" stroke-width="2">
                          <path
                            d="M4 8l3 3 5-5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      Re-render anytime
                    </div>
                    <div className="feature">
                      <span className="check">
                        <svg viewBox="0 0 16 16" fill="none" stroke-width="2">
                          <path
                            d="M4 8l3 3 5-5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      Custom fonts and studio logos
                    </div>
                    <div className="feature">
                      <span className="check">
                        <svg viewBox="0 0 16 16" fill="none" stroke-width="2">
                          <path
                            d="M4 8l3 3 5-5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </span>
                      Major frame rates & formats
                    </div>
                  </div>

                  <div className="settings-mock">
                    <div className="settings-head">
                      <span>Project Settings</span>
                      <span className="settings-badge">Saved</span>
                    </div>

                    <div className="settings-body">
                      <div className="settings-panel">
                        <div className="setting-row">
                          <div className="setting-label">Template</div>
                          <div className="setting-box">
                            Modern Roll <span>▾</span>
                          </div>
                        </div>
                        <div className="setting-row">
                          <div className="setting-label">Font</div>
                          <div className="setting-box">
                            Helvetica Neue <span>▾</span>
                          </div>
                        </div>
                        <div className="setting-row">
                          <div className="setting-label">Alignment</div>
                          <div className="align-mini">
                            <div>≡</div>
                            <div className="active">≡</div>
                            <div>≡</div>
                          </div>
                        </div>
                        <div className="setting-row">
                          <div className="setting-label">Scroll Speed</div>
                          <div className="speed-track"></div>
                        </div>
                      </div>

                      <div className="settings-preview">
                        <div className="preview-credit">
                          <span className="role">Edited by</span>
                          <span className="name">ZOE CARTER</span>
                          <span className="meta">4K · 23.98fps · ProRes</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="note">
                    <div className="avatarLogin ">SX</div>
                    <div>
                      Your credit rolls, fonts, logos, and exports stay
                      organized in one place.
                      <strong>Ready for last-minute changes</strong>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
        </div>
      </div>
    </>
  );
};

export default Login;
